import { render } from "./mini-calendar-events.vue?vue&type=template&id=6fc5be51"
import script from "./mini-calendar-events.vue?vue&type=script&lang=js"
export * from "./mini-calendar-events.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bradwalker/Sites/clark-atlanta-university/web/modules/custom/idfive_calendar_client/calendar_vue_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__